import {
  Button,
  CircularProgress,
  InputAdornment,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import images from "../../../../Utils/importImages";
import ResetPasswordVerify from "./ResetPasswordVerify";
import Swal from "sweetalert2";
import {
  setisAdminLogin,
  setisUserLogin,
  setUserLoggedInData,
} from "../../../../Redux/Slices/User_Slices/User-SLICE";
import {
  removeLocalStorageJSON,
  setLocalStorageJSON,
} from "../../../../Utils/localStorageFunc";
import { useDispatch, useSelector } from "react-redux";
import {
  LoginWithAuthenticator,
  LoginWithOtp,
  sendOtp,
} from "../../../../Redux/Apis/User-Apis";

function VerifyUser({ onClose, setUserExist, credential, credentialType }) {
  let dispatch = useDispatch();

  // The actually-selected region/pipeline (set by the region dropdown in Header.jsx) — a user
  // account is scoped to the pipeline it registered under, so login/OTP calls must use the same
  // pipeline the user is currently browsing under instead of a hardcoded one.
  const selectedPipelineId = useSelector((state) => state.user.selectedPipelineId);

  const [inputText, setInputText] = useState("");
  const [textError, setTextError] = useState("");

  let [activeTab, setActiveTab] = useState("Password");

  const onChangeInput = (e) => {
    setInputText(e.target.value);
  };

  let [btnLoading, setBtnLoading] = useState(false);

  const handleSubmit = async () => {
    setBtnLoading(true);

    let resp = activeTab == "Password" ? await LoginWithAuthenticator(
      { identifier: credential, password: inputText, pipeline_id: selectedPipelineId },
      true
    ) : await LoginWithOtp(
      { identifier: credential, otp: inputText, pipeline_id: selectedPipelineId },
      true
    );

    setBtnLoading(false);

    if (resp.error == false) {
      dispatch(setUserLoggedInData(resp.data.user));
      removeLocalStorageJSON("AL");
      setLocalStorageJSON("UL", resp.data.token);
      dispatch(setisUserLogin(true));
      dispatch(setisAdminLogin(false));
      onClose("Login");
    }
  };

  let [openResetPassword, setOpenResetPassword] = useState(false);
  let [resetPassLoading, setResetPassLoading] = useState(false);

  const handleResetPassword = async () => {
    // reset password opening
    setResetPassLoading(true);

    let request = { pipeline_id: selectedPipelineId };
    request[credentialType] = credential;

    await sendOtp(
      request,
      credentialType == "email" ? "/resend-otp/email" : "/resend-otp/phone"
    );
    setResetPassLoading(false);

    setOpenResetPassword(true);
    setActiveTab("Password");
    setInputText("");
    setTextError("");
  };

  const [isResendDisabled, setIsResendDisabled] = useState(false);

  const [timer, setTimer] = useState(60); // Initial timer for 60 seconds

  const [resendLoading, setResendLoading] = useState(false);

  let [isFirst, setisFirst] = useState(true);
  const handleResendClick = async () => {
    if (!isResendDisabled) {
      setisFirst(false);
      setResendLoading(true);

      let request = {};
      request[credentialType] = credential;

      await sendOtp(
        request,
        credentialType == "email" ? "/resend-otp/email" : "/resend-otp/phone"
      );

      setResendLoading(false);

      setIsResendDisabled(true);
      setTimer(60); // Reset timer to 60 seconds

      // Countdown function
      const countdown = setInterval(() => {
        setTimer((prevTime) => {
          if (prevTime === 1) {
            clearInterval(countdown);
            setIsResendDisabled(false); // Enable after 60 seconds
          }
          return prevTime - 1;
        });
      }, 1000);
    }
  };

  const validateInputField = (type, value) => {
    if (!value) {
      setTextError("*Required");
      return false;
    } else {
      if (value.length < 6) {
        setTextError(`${type} Must be of 6 Characters`);
        return false;
      } else {
        setTextError("");
        return true;
      }
    }
  };

  let validateInput = () => {
    validateInputField(activeTab, inputText);
  };

  return openResetPassword == false ? (
    <div className="register-login">
      <div
        className="back-text proxima_semibold color_endeavour font12"
        onClick={() => setUserExist(false)}
      >
        BACK
      </div>

      <div className="header">
        <img
          src={images["user-login-icon.svg"]}
          alt=""
          className="login-icon"
        />
        <div className="title proxima_semibold color_black font22">
          Login With {activeTab}
        </div>
      </div>

      <div className="switch-wrapper">
        <div
          className={`switch-tab proxima_semibold color_black font16 ${
            activeTab == "Password" && "active"
          }`}
          onClick={() => {
            setActiveTab("Password");
            setInputText("");
            setTextError("");
          }}
        >
          Password
        </div>
        <div
          className={`switch-tab proxima_semibold color_black font16 ${
            activeTab == "OTP" && "active"
          }`}
          onClick={() => {
            setActiveTab("OTP");
            setInputText("");
            setTextError("");
          }}
        >
          OTP
        </div>
      </div>

      {activeTab == "OTP" && (
        <div className="otp proxima_semibold color_black font12">
          Verify OTP sent to {credentialType.toUpperCase()}
        </div>
      )}

      <div className="input-content">
        <TextField
          autoComplete="off"
          error={!!textError}
          helperText={textError}
          value={inputText}
          onChange={onChangeInput}
          onBlur={validateInput}
          id="outlined-basic"
          label={`Enter ${activeTab}`}
          variant="outlined"
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              fontFamily: `var(--font-family-proxima_nova-regular)`,
              fontStyle: "normal",
              fontWeight: "400",
              "&.Mui-focused": {
                color: "#0057B7",
              },
            },
            "& .MuiOutlinedInput-root": {
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {activeTab == "Password" ? (
                  <div
                    className="resend-otp proxima_semibold font13 color_endeavour"
                    onClick={handleResetPassword}
                    style={{
                      cursor: "pointer",
                      color: "#0057B7",
                      textDecorationColor: "#0057B7",
                    }}
                  >
                    {" "}
                    {resetPassLoading ? (
                      <CircularProgress size={18} sx={{ color: "#0057B7" }} />
                    ) : (
                      "Reset Password"
                    )}
                    {}
                  </div>
                ) : (
                  <div
                    className={`resend-otp proxima_semibold font13 ${
                      isResendDisabled ? "disabled" : "color_endeavour"
                    }`}
                    onClick={handleResendClick}
                    style={{
                      cursor: isResendDisabled ? "not-allowed" : "pointer",
                      color: isResendDisabled ? "#B0B0B0" : "#0057B7",
                      textDecorationColor: isResendDisabled
                        ? "#B0B0B0"
                        : "#0057B7",
                    }}
                  >
                    {resendLoading ? (
                      <CircularProgress size={18} sx={{ color: "#0057B7" }} />
                    ) : isFirst ? (
                      "Send OTP"
                    ) : (
                      "Resend OTP"
                    )}
                  </div>
                )}
              </InputAdornment>
            ),
          }}
        />
      </div>

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={!inputText || btnLoading}
        sx={{
          width: "100%",
          backgroundColor: "#0057B7",
          color: "#fff",
          fontSize: "16px",
          fontFamily: `var(--font-family-proxima_nova-regular)`,
          fontWeight: "600",
          marginTop: "10px",
          textTransform: "none",
          "&:hover": { backgroundColor: "#0045A5" },
          "&:disabled": {
            backgroundColor: "#B0B0B0",
            color: "#fff",
            cursor: "not-allowed",
          },
        }}
      >
        {btnLoading ? (
          <CircularProgress size={24} sx={{ color: "white" }} />
        ) : (
          "LOGIN"
        )}
      </Button>

      <div className="tandc color_light-gray-black font14 proxima_regular">
        By proceeding, you agree to TripPrizer's
        <span className="color_endeavour">Privacy Policy, User Agreement</span>
        and <span className="color_endeavour">T&Cs</span>
      </div>
    </div>
  ) : (
    <ResetPasswordVerify
      setOpenResetPassword={setOpenResetPassword}
      credential={credential}
      credentialType={credentialType}
    />
  );
}

export default VerifyUser;
